import DonutChart from "../../component/Dashboard/DonutChart";
import { MessageSquare } from "lucide-react";

const CommunicationChannelsComponent = ({ dashboardData }) => {
  const communicationChannelsData = [
    {
      label: "WhatsApp",
      value: dashboardData?.channel?.whatsapp || 0,
      color: "#133F7D",
    },
    {
      label: "Call",
      value: dashboardData?.channel?.call || 0,
      color: "#D68000",
    },
  ];

  return (
    <div className="">
      <DonutChart
        data={communicationChannelsData}
        title="Communication Channels"
        totalValue={dashboardData?.channel?.total || 0}
        centerLabel="Total Channels"
        icon={<MessageSquare style={{ color: "#0D9488" }} />}
        layout="position-status"
      />
    </div>
  );
};

export default CommunicationChannelsComponent;
